export default "__VITE_ASSET__DUUl1CL$__"